module.exports = __webpack_public_path__ + "static/media/coruche.f031fb55.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/assets/coruche.png
// module id = 547
// module chunks = 0